
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class OrderOnboardingViewModel extends Model<OrderOnboardingViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'taskflowId', type: 'string' },
		{ name: 'responsibleUserId', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'companyName', type: 'string' },
		{ name: 'orders', type: 'OrderDataModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderDataModel }, properties: () => { return OrderDataModel.classProperties } },
		{ name: 'activeQualificationCall', type: 'boolean' }
	];
	[key: string]: any;
	
	public taskflowId?: string;
	public responsibleUserId?: string;
	public companyId?: string;
	public companyName: string;
	public orders: OrderDataModel[];
	public activeQualificationCall: boolean;
    
	constructor(){
		super();
		this.taskflowId = undefined;
		this.responsibleUserId = undefined;
		this.companyId = undefined;
		this.companyName = '';
		this.orders = [];
		this.activeQualificationCall = false;
		
	}
	getProperties(){
		return OrderOnboardingViewModel.classProperties;
	}
}
export class OrderDataModel extends Model<OrderDataModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'orderId', type: 'string' },
		{ name: 'approvedDate', type: 'Date' },
		{ name: 'products', type: 'ProductDataModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductDataModel }, properties: () => { return ProductDataModel.classProperties } }
	];
	[key: string]: any;
	
	public orderId?: string;
	public approvedDate?: Date;
	public products: ProductDataModel[];
    
	constructor(){
		super();
		this.orderId = undefined;
		this.approvedDate = undefined;
		this.products = [];
		
	}
	getProperties(){
		return OrderDataModel.classProperties;
	}
}
export class ProductDataModel extends Model<ProductDataModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'orderLineId', type: 'string' },
		{ name: 'name', type: 'string' },
		{ name: 'productValue', type: 'number' },
		{ name: 'invoiced', type: 'Date' },
		{ name: 'containOpenOnboardingTaskflows', type: 'boolean' }
	];
	[key: string]: any;
	
	public orderLineId?: string;
	public name: string;
	public productValue: number;
	public invoiced?: Date;
	public containOpenOnboardingTaskflows: boolean;
    
	constructor(){
		super();
		this.orderLineId = undefined;
		this.name = '';
		this.productValue = 0;
		this.invoiced = undefined;
		this.containOpenOnboardingTaskflows = false;
		
	}
	getProperties(){
		return ProductDataModel.classProperties;
	}
}

